"use client";

import React from "react";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const progressionStats = [{
  label: "Destinations",
  value: "72+",
  targetProgress: 88
}, {
  label: "Expeditions",
  value: "1.4K",
  targetProgress: 75
}, {
  label: "Happy Travelers",
  value: "25K",
  targetProgress: 95
}, {
  label: "Expert Guides",
  value: "120",
  targetProgress: 82
}];
export default function GlobalFootprint() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="223581" id="global-footprint" className="dark bg-background text-foreground py-16 md:py-24 px-6 border-y border-border/10 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-secondary/10 via-background/0 to-background/0 pointer-events-none opacity-50" />
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `radial-gradient(var(--color-secondary) 1px, transparent 0)`,
      backgroundSize: '24px 24px'
    }} />

      <div ref={ref} className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 md:gap-16">
          {progressionStats.map((stat, i) => <div key={i} data-index={i} className={`flex flex-col gap-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="flex flex-col gap-1">
                <span className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-secondary font-medium">
                  {stat.label}
                </span>
                <span className="text-5xl md:text-7xl font-default font-bold tracking-tighter text-primary drop-shadow-[0_0_15px_rgba(255,191,0,0.3)]">
                  {stat.value}
                </span>
              </div>
              
              <div className="w-full pt-2">
                <Progress value={isVisible ? stat.targetProgress : 0} className="h-1.5 rounded-md bg-muted/30 [&>div]:rounded-md" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}